module.exports = __webpack_public_path__ + "static/media/menu_1.7cb64f32.webp";